export const headerTranslation = {
    contact_us: 'Contact us',
    language: 'Language', // Texto do lado do ícone do languageMenu
    language_menu: {
      portuguese: 'Portuguese',
      english: 'English',
    }
  };
  